module.exports = __webpack_public_path__ + "img/beer.75ebc9e7.gif";